import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import {setGroheSameColorCheckboxApplied} from "../../../../../actions/groheFunctions";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import Analytics from "../../../../../analytics";


const LookFeatureColorMatchCheckbox = (props) => {

  const {sameColorFeatures, currentColorFeatures, groheSameColorCheckboxApplied, setGroheSameColorCheckboxApplied,
    intl, groheSameColorActiveFeature, analyticsLabel, checkboxText} = props;

  const checkboxClick = (updateAllLookCartItems) => {
    // console.log("currentColorFeatures", currentColorFeatures);
    // console.log("sameColorFeatures", sameColorFeatures);
    Analytics.sendClickEvent(analyticsLabel + !groheSameColorCheckboxApplied);

    const featuresToClick = groheSameColorCheckboxApplied ? currentColorFeatures : sameColorFeatures;
    setGroheSameColorCheckboxApplied(!groheSameColorCheckboxApplied);
    updateAllLookCartItems(featuresToClick, groheSameColorActiveFeature, false, true);
  }

  return (
    <WithUpdateLookCartItem>
      {(updateLookCartItem, updateAllLookCartItems) => (
        <FormControlLabel
          control={
            <Switch
              className="gm-ios-checkbox"
              disableRipple
              checked={groheSameColorCheckboxApplied}
              onChange={() => checkboxClick(updateAllLookCartItems)}
              color="primary"
            />
          }
          label={intl.formatMessage({id: checkboxText || "grohe.sameColor.checkbox"})}
        />
      )}
    </WithUpdateLookCartItem>
  )
};

LookFeatureColorMatchCheckbox.propTypes = {
  sameColorFeatures: PropTypes.array.isRequired,
  currentColorFeatures: PropTypes.array.isRequired,
  analyticsLabel: PropTypes.string,
  checkboxText: PropTypes.string,
};

const mapStateToProps = (store) => {
  const {groheSameColorCheckboxApplied, groheSameColorActiveFeature} = store.groheState;
  const {filterGroups} = store.filterState;
  return {
    groheSameColorCheckboxApplied,
    groheSameColorActiveFeature,
    filterGroups,
  };
};

const mapDispatchToProps = {
  setGroheSameColorCheckboxApplied
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureColorMatchCheckbox)
)
